const slice = 'edit';

export const SET_CURRENT_EDITED_BOOK = `${slice}/currentEditedBook`;

export const RESET_EDITED_BOOK = `${slice}/resetEditedBook`;